// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM = "Diskusie";
export const REVIEW_SECTION_OFFER = "Ponuka";
export const STROLLER_QUESTIONS_AND_ANSWERS = "Ot\u00e1zky a odpovede";
export const STROLLER_REVIEWS = "Hodnotenia";
